App.directive('inputText', ['$window', 'Config', '$filter', function ($window, Config, $filter) {
    return {
        restrict: 'AEC',
        scope: {
            form: '=',
            name: '@',
            placeholder: '@',
            notBorder: '=',
            notBg: '=',
            hint: '@',
            label: '@',
            value: '@',
            notAvailable: '=',
            model: '=',
            required: '=',
            pattern: '@',
            addCheck: '@',
            maxlength: '@',
            pre: '@',
            suf: '@',
            uimask: '@',
            validationRequired: '=?'
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/input-text.html',
        link: function (scope) {
            scope.minlength = parseInt(scope.minlength) || 0;
            scope.validationRequired = !!scope.validationRequired;

            scope.regex = {
                firstName: {
                    value: /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s]{3,40}$/,
                    error: 'Nieprawidłowe imię (3-40 znaków, litery lub spacje)'
                },
                lastName: {
                    value: /^(?!.*([\-\s])\1.*|^[\-\s]|.*[\-\s]$)[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻäöüÄÖÜ\s\-]{2,40}$/,
                    error: 'Nieprawidłowe nazwisko (2-40 znaków, litery, spacje lub myślniki)'
                },
                email: {
                    value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    error: 'Nieprawidłowy adres e-mail'
                },
                identifier: {
                    error: 'Nieprawidłowy numer pesel'
                },
                zipcode: {
                    value: '',
                    error: 'Nieprawidłowy kod pocztowy'
                },
                birthdate: {
                    value: /[0-9]{2}[.]{1}[0-9]{2}[.]{1}[0-9]{4}/,
                    error: 'Nieprawidłowa data urodzenia (dd.mm.rrrr)'
                },
                birthplace: {
                    value: /^(?!.*([\-\s])\1.*|^[\-\s]|.*[\-\s]$)[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s\-]{2,50}$/,
                    error: 'Nieprawidłowe miejsce urodzenia (2-50 znaków, litery, spacje lub myślniki)'
                },
                addressNumber: {
                    value: /^(?!.*([\\/])\1.*|^[\\/]|.*[\\/]$)[0-9a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\\/]{1,38}$/,
                    error: 'Nieprawidłowe znaki - dopuszczalne tylko cyfry, litery oraz /'
                },
                city: {
                    value: /^(?!.*([\-\s])\1.*|^[\-\s]|.*[\-\s]$)[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s\-]{1,100}$/,
                    error: 'Nieprawidłowe znaki (2-100 znaków, litery, spacje lub myślniki)'
                },
                number: {
                    value: /^\d+$/,
                    error: 'Nieprawidłowe znaki - dopuszczalne tylko cyfry'
                },
                price: {
                    value: /^\d+?([,.]\d{1,2})?$/,
                    error: 'Nieprawidłowa cena'
                },
                login: {
                    value: /[0-9a-zA-Z!@#$%^&*()_+-=]{6,}/,
                    error: 'Nieprawidłowy login - min. 6 znaków (bez polskich znaków)'
                },
                phone: {
                    value: /^\d{9}$/,
                    error: 'Nieprawidłowy numer telefonu - wymagane 9 cyfr'
                },
                oirpGdanskHrNumber: {
                    value: /^(GD|E)\/\d\d\d\d?$/i,
                    error: 'Numer wpisu na listę radców prawnych. Ma postać GD/GD/XXXX albo GD/E/XXXX'
                },
                oirpKatowiceHrNumber: {
                    value: /^(KT)B?\d\d\d\d?$/i,
                    error: 'Numer wpisu na listę radców prawnych. Ma postać KTXXXX'
                },
                oirpLodzHrNumber: {
                    value: /^(M-|P-|SK-|S-|)\d+$/i,
                    error: 'Numer wpisu na listę radców prawnych. Ma postać ŁD-M-XXXX, ŁD-P-XXXX, ŁD-SK-XXXX, ŁD-S-XXXX albo ŁD-XXXX'
                },
                oirpLublinHrNumber: {
                    value: /^(\/B\/|\/CH\/|\/Z\/|-)\d{1,8}$/i,
                    error: 'Numer wpisu na listę radców prawnych. Ma postać LB-XXXX, LB/B/XXXX, LB/CH/XXXX,  LB/Z/XXXX'
                }
            };

            if (!scope.required && !scope.validationRequired) {
                scope.regex[scope.pattern] = {};
            }

            if (scope.addCheck && scope.addCheck.length) {
                scope.checkAddValid = function () {
                    if (scope.addCheck === 'identifier') {
                        var status = $filter('checkIdentifier')(scope.model);

                        if (status) {
                            scope.form[scope.name].$valid = true;
                        } else {
                            scope.form.$valid = false;
                            scope.form[scope.name].$valid = false;
                        }
                    }
                };

                if (scope.addCheck === 'identifier') {
                    var status = $filter('checkIdentifier')(scope.model);

                    if (!status) {
                        scope.model = '';
                    }
                }
            }
        }
    };
}]);
